/* Doodle Dreams – real Shopify Bundles integration.
 * Bundle variant IDs were verified in the connected Shopify store.
 * Styling is intentionally untouched. */
(function () {
  if (window.__ddConnectedBundlesInstalled) return;
  window.__ddConnectedBundlesInstalled = true;
  const bundleVariants = {"blanket":[[67705968198000,67705992642928,67705992675696,67705992708464],[67705992741232,67705992774000,67705992806768,67705992839536],[67705992872304,67705992905072,67705992937840,67705992970608],[67705993003376,67705993036144,67705993068912,67705993101680]],"pillow":[[67705968263536,67705998246256,67705998279024,67705998311792],[67705998344560,67705998377328,67705998410096,67705998442864],[67705998475632,67705998508400,67705998541168,67705998573936],[67705998606704,67705998639472,67705998672240,67705998705008]],"pyjamas":[[67705968787824,67705999982960],[67706000015728,67706000048496]],"markers":67705968886128};
  const names = {blanket:['Cats & Dogs','Monsters','Mushrooms','Flowers'],pillow:['Cats & Dogs','Monsters','Mushrooms','Flowers'],pyjamas:['Girl','Boy']};
  // The new Simple Bundles Infinite Options pyjama Duo: 2 independent styles,
  // 2 independent sizes, and 1 included marker set (Shopify-verified variant).
  const pyjamaDuoVariantId = 67715010789744;
  const markerId = 67644994683248;
  const money = (c) => 'R' + (c / 100).toLocaleString('en-ZA', {minimumFractionDigits:2,maximumFractionDigits:2});
  let ddCartRefreshSequence = 0;

  function selectedVariant(root, kind) {
    if (kind === 'markers') return bundleVariants.markers;
    const selects = Array.from(root.querySelectorAll('#option-2-variant-' + root.dataset.sectionId + ' select'));
    // Some themes omit this section-specific id; both independent selectors are inside Buy 2.
    const chosen = selects.length === 2 ? selects : Array.from(root.querySelectorAll('label[for="quantity2"] .quantity-break__variant-select'));
    const choices = chosen.map(sel => (sel.selectedOptions[0]?.textContent || '').trim());
    const possible = names[kind] || [];
    // No implicit replacement: invalid or missing variants should never charge the wrong bundle.
    if (possible.length && choices.length !== 2) return null;
    const a = possible.findIndex(x => x.toLowerCase() === choices[0]?.toLowerCase());
    const b = possible.findIndex(x => x.toLowerCase() === choices[1]?.toLowerCase());
    return a >= 0 && b >= 0 ? bundleVariants[kind]?.[a]?.[b] : null;
  }
  function choiceNotice(bundleBox, message) {
    let bar=bundleBox.nextElementSibling;
    if (!bar?.classList?.contains('dd-bundle-choice-message')) {
      bar=document.createElement('div');
      bar.className='dd-bundle-choice-message';
      bar.setAttribute('role','alert');
      bar.hidden=true;
      bar.innerHTML='<span class="dd-choice-warning" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.3 4.6a2 2 0 0 1 3.4 0l8 13.2a2 2 0 0 1-1.7 3H4a2 2 0 0 1-1.7-3l8-13.2Z"/><path d="M12 9v5"/><circle cx="12" cy="17.4" r=".8" fill="currentColor" stroke="none"/></svg></span><span class="dd-choice-message-text"></span>';
      bundleBox.insertAdjacentElement('afterend',bar);
    }
    bar.querySelector('.dd-choice-message-text').textContent=message;
    bar.hidden=false;
  }
  function clearChoiceNotice(bundleBox) {
    const bar=bundleBox?.nextElementSibling;
    if (bar?.classList?.contains('dd-bundle-choice-message')) bar.hidden=true;
  }
  // Sticky purchase has its own selection warning, using the same styling and
  // wording as the Starter/Duo/Special bundle warnings above the page.
  function stickyChoiceNotice(stickyBar, message) {
    const container=stickyBar?.querySelector('.dd-sticky-atc-container');
    if (!container) return;
    let notice=container.querySelector('.dd-sticky-choice-message');
    if (!notice) {
      notice=document.createElement('div');
      notice.className='dd-bundle-choice-message dd-sticky-choice-message';
      notice.setAttribute('role','alert');
      notice.innerHTML='<span class="dd-choice-warning" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.3 4.6a2 2 0 0 1 3.4 0l8 13.2a2 2 0 0 1-1.7 3H4a2 2 0 0 1-1.7-3l8-13.2Z"/><path d="M12 9v5"/><circle cx="12" cy="17.4" r=".8" fill="currentColor" stroke="none"/></svg></span><span class="dd-choice-message-text"></span>';
      container.prepend(notice);
    }
    notice.querySelector('.dd-choice-message-text').textContent=message;
    notice.hidden=false;
  }
  document.addEventListener('change', (event) => {
    if (event.target.matches('.dd-bundle-options .dd-style-dropdown, .dd-bundle-options .dd-special-design-select, .dd-bundle-options .dd-pyj-duo-selects select, .dd-bundle-options input[name="quantity"]')) {
      clearChoiceNotice(event.target.closest('.dd-bundle-options'));
    }
  });
  function error(form, message) {
    const wrap=form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    if (wrap) {
      const msg=wrap.querySelector('.product-form__error-message');
      if (msg) msg.textContent = message;
      wrap.hidden=false;
    } else alert(message);
  }
  document.addEventListener('submit', async function(event) {
    const form=event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('product-form form[data-type="add-to-cart-form"]')) return;
    const productInfo=form.closest('product-info');
    if (!productInfo) return;
    const bundleBox=productInfo.querySelector('.dd-bundle-options[data-dd-bundle-kind]');
    if (!bundleBox) return;
    const kind=bundleBox.dataset.ddBundleKind;
    if (!bundleVariants[kind]) return;
    const duo=bundleBox.querySelector('#quantity2')?.checked === true;
    const specialRadio=kind==='blanket' ? bundleBox.querySelector('input.dd-special-radio:checked') : null;
    const addon=bundleBox.querySelector('.dd-marker-addon input[type="checkbox"]');
    // Handle Starter as well as Duo here. Native quantity-break form fields may
    // retain two stale variant IDs after switching away from Duo; always send
    // exactly the customer's current selection instead of those old fields.
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.ddSubmitting === 'true') return;
    let items;
    // The marker product's sticky bar is a standalone Add to Cart shortcut.
    // Do not let the preselected Duo offer hijack its submit event.
    // Other Add to Cart controls retain their existing Starter/Duo/Special behavior.
    const stickyButton=event.submitter?.closest('.dd-sticky-atc__add');
    const stickyBar=stickyButton?.closest('.dd-sticky-atc');
    const singleMarkerStickyButton = kind === 'markers' &&
      stickyBar?.classList.contains('dd-sticky-atc--markers');
    if (stickyBar && !singleMarkerStickyButton) {
      // Bottom Add to Cart means precisely ONE selected product variant.
      // Never use the selected Starter/Duo/Special bundle, paid add-on checkbox,
      // free marker components or any stale multi-item form data here.
      const stickyPicker=stickyBar.querySelector('[data-dd-sticky-variant-selector]');
      const selectedOption=stickyPicker?.selectedOptions?.[0];
      const stickyId=Number(stickyPicker?.value);
      if (!stickyId || selectedOption?.disabled) {
        stickyChoiceNotice(stickyBar, 'Please select a design.');
        stickyPicker?.focus({preventScroll:true});
        return;
      }
      const priorNotice=stickyBar.querySelector('.dd-sticky-choice-message');
      if (priorNotice) priorNotice.hidden=true;
      items=[{id:stickyId,quantity:1}];
    } else if (singleMarkerStickyButton) {
      const standaloneId = Number(event.submitter.dataset.ddSingleMarkerVariant || markerId);
      if (!standaloneId) {
        error(form, 'Please try again.');
        return;
      }
      items=[{id:standaloneId, quantity:1}];
    } else if (specialRadio) {
      // This is a Simple Bundles 2.0 Infinite Options bundle, not the native
      // Shopify Duo variant. The app resolves the selected component variants
      // using these exact property names from its four dropdown option groups.
      const card=bundleBox.querySelector('label[for="'+specialRadio.id+'"]');
      const parentId=Number(card?.dataset.ddSpecialVariant);
      const selects=Array.from(card?.querySelectorAll('.dd-special-design-select')||[]);
      if (!parentId || selects.length!==4 || selects.some(el=>!el.value)) {
        choiceNotice(bundleBox,'Please select a design.');
        return;
      }
      const properties={};
      for (const el of selects) {
        const key=el.dataset.ddSpecialOption;
        if(!key || !el.value) {
          choiceNotice(bundleBox,'Please select a design.');
          return;
        }
        properties[key]=el.value;
      }
      // The fifth app option group is fixed at four marker sets.
      // Keep the property so Simple Bundles can associate that component.
      properties['FREE Markers']='Doodle Dreams™ Acrylic Marker Set';
      items=[{id:parentId,quantity:1,properties}];
    } else if (duo) {
      if (kind === 'pyjamas') {
        // The old 4-option Girl/Boy Duo cannot represent sizes. Use the new
        // Simple Bundles parent plus the exact app dropdown property names.
        const rows=Array.from(bundleBox.querySelectorAll('.dd-pyj-duo-row'));
        if (rows.length!==2 || !pyjamaDuoVariantId) {
          choiceNotice(bundleBox,'Please select a size.');
          return;
        }
        const properties={};
        for (const row of rows) {
          const style=row.querySelector('.dd-pyj-style-select');
          const size=row.querySelector('.dd-pyj-size-select');
          if (!style?.value || !size?.value) {
            choiceNotice(bundleBox,'Please select a style and size for both pyjamas.');
            return;
          }
          properties[style.dataset.ddPyjProperty]=style.value;
          properties[size.dataset.ddPyjProperty]=size.value;
        }
        properties['Marker']='Doodle Dreams™ Acrylic Marker Set';
        items=[{id:pyjamaDuoVariantId,quantity:1,properties}];
      } else {
        const id=selectedVariant(bundleBox, kind);
        if (!id) {
          choiceNotice(bundleBox,'Please select a design.');
          return;
        }
        // Free marker sets are INCLUDED in the Shopify Bundle components.
        items=[{id:Number(id),quantity:1}];
      }
    } else {
      const starterPicker=bundleBox.querySelector('[id^="option-1-variant-"] select.dd-style-dropdown');
      let variantId;
      if (kind === 'pyjamas') {
        const style=bundleBox.querySelector('.dd-pyj-starter-style')?.value;
        const size=bundleBox.querySelector('.dd-pyj-starter-size')?.value;
        if (!style || !size) {
          choiceNotice(bundleBox, 'Please select a style and size.');
          return;
        }
        let variants=[];
        try {
          const picker=productInfo.querySelector('variant-radios.dd-style-pills [type="application/json"]');
          variants=JSON.parse(picker?.textContent || '[]');
        } catch (_) { variants=[]; }
        const exactVariant=variants.find(v=>v.option1===style && v.option2===size);
        variantId=Number(exactVariant?.id);
      } else {
        // Do not fall back to a hidden default ID if the visible picker still says Select.
        const selectedId=starterPicker ? starterPicker.value : (form.querySelector('input[name="id"]')?.value || '').split(',')[0];
        variantId=Number(selectedId);
      }
      if (!variantId) {
        choiceNotice(bundleBox, 'Please select a valid style and size.');
        return;
      }
      items=[{id:variantId,quantity:1}];
      if (addon?.checked && kind !== 'markers') {
        const additionalMarker=Number(bundleBox.querySelector('.dd-marker-addon')?.dataset.markerVariant || markerId);
        items.push({id:additionalMarker,quantity:1,properties:{'_Doodle Dreams offer':'Doodle Starter paid marker add-on','_Doodle Dreams source':kind}});
      }
    }
    const btn=form.querySelector('[type="submit"]');
    const spinner=btn?.querySelector('.loading-overlay__spinner');
    const formEl=form.closest('product-form');
    const drawer=document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const sectionIds=drawer?.getSectionsToRender?.().map(v=>v.id) || [];
    form.dataset.ddSubmitting='true';
    if (btn) {btn.setAttribute('aria-disabled','true');btn.classList.add('loading');}
    spinner?.classList.remove('hidden');
    try {
      const res=await fetch((window.Shopify?.routes?.root || '/')+'cart/add.js',{
        method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:JSON.stringify({items,sections:sectionIds,sections_url:window.location.pathname})
      });
      const data=await res.json();
      if (!res.ok || data.status) throw Error(data.description || data.message || 'Unable to add your selection to the cart.');
      if (form.querySelector('input[name="id"]')?.dataset.skipCart === 'true') {
        window.location.href=(window.Shopify?.routes?.root || '/')+'checkout';
        return;
      }
      // Show the successful Shopify add immediately, exactly as for Special.
      // A second Starter may need conversion into a real discounted Duo, but
      // waiting for those additional network requests must not delay the drawer.
      const standaloneStarter = ['blanket','pillow','pyjamas'].includes(kind) &&
        (stickyBar ? !singleMarkerStickyButton : (!duo && !specialRadio));
      const refreshSequence = ++ddCartRefreshSequence;
      if (drawer?.renderContents && data.sections) {
        drawer.setActiveElement?.(document.activeElement);
        drawer.renderContents(data);
        // The automatic Duo conversion is an asynchronous cart normalization.
        // Keep the cart section accurate when it completes, without delaying
        // the initial drawer opening for the user.
        if (standaloneStarter && typeof window.ddUpgradeCartBeforeDrawer === 'function') {
          (async () => {
            try {
              const upgraded=await window.ddUpgradeCartBeforeDrawer();
              if (!upgraded) return;
              const url=window.location.pathname+'?sections='+encodeURIComponent(sectionIds.join(','));
              const res=await fetch(url,{cache:'no-store'});
              if (!res.ok) throw Error('Could not refresh the discounted cart');
              const finalSections=await res.json();
              if (!sectionIds.every(id=>typeof finalSections[id]==='string')) return;
              // A newer addition has already drawn its own contents. It will
              // perform its own final refresh and must not be overwritten.
              if (refreshSequence !== ddCartRefreshSequence) return;
              drawer.renderContents({sections:finalSections});
            } catch(e) {
              console.warn('[Doodle Dreams] Cart refresh after bundle upgrade:',e);
            }
          })();
        }
        const themeEvent=window.PUB_SUB_EVENTS?.cartUpdate;
        if (themeEvent && typeof window.publish === 'function') {
          // Avoid triggering an overlapping conversion from the pub/sub event:
          // the promise above handles this Starter addition.
          window.publish(themeEvent,{source:'product-form',ddBundleCartSettled:standaloneStarter});
        }
      } else {
        window.location.href=(window.Shopify?.routes?.root || '/')+'cart';
      }
    } catch(e) {
      console.error('[Doodle Dreams bundles]',e);
      error(form,e.message || 'Please try again.');
    } finally {
      form.dataset.ddSubmitting='false';
      btn?.classList.remove('loading');
      btn?.removeAttribute('aria-disabled');
      spinner?.classList.add('hidden');
    }
  },true);
})();
